export default __webpack_public_path__ + "static/media/promotions_graphics.21cd561c.png";